import {ControlledInput} from '@hm/fundamental'
import {useCallback} from 'react'
import {Controller, useFieldArray, useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {DrillingSettingsCheckboxes} from './DrillngSettingsCheckboxes'

import {DrillingPosition} from '@refra/modules/refra-planning/types'

export const DrillingPositions = () => {
  let maxWidth = (window.innerWidth - 200) / 2
  if (maxWidth > 150) maxWidth = 150

  const radius = maxWidth // radius for checkboxes and circle line
  const labelOffset = 30 // outside label distance
  const centerX = maxWidth + 50 // SVG canvas center x
  const centerY = maxWidth + 50 // SVG canvas center y

  const {t} = useTranslation()
  const {control, watch} = useFormContext<{drillingPositions: DrillingPosition[]}>()
  const {fields} = useFieldArray<{drillingPositions: DrillingPosition[]}, 'drillingPositions'>({
    control,
    name: 'drillingPositions'
  })

  const formWatch = watch()
  const values = formWatch.drillingPositions.filter((field) => field.isEnabled)

  const renderFormField = useCallback(
    (value: DrillingPosition) => {
      const index = fields.findIndex((f) => f.angle === value.angle)
      return (
        <div
          key={`drillingPositions.${index}.name`}
          className="flex flex-col"
          data-test-id="drilling_position_input"
        >
          <Controller
            name={`drillingPositions.${index}.name`}
            control={control}
            rules={{required: t('error.required')}}
            render={({field}) => <ControlledInput {...field} label={value.angle} />}
          />
        </div>
      )
    },
    [fields, control, t]
  )

  return (
    <div>
      <div className="flex justify-center">
        <DrillingSettingsCheckboxes
          radius={radius}
          labelOffset={labelOffset}
          centerX={centerX}
          centerY={centerY}
          fields={fields}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col gap-3">
          {values.filter((_, index) => index % 2 === 0).map((field) => renderFormField(field))}
        </div>
        <div className="flex flex-col gap-3">
          {values.filter((_, index) => index % 2 !== 0).map((field) => renderFormField(field))}
        </div>
      </div>
    </div>
  )
}
